import React, { useState } from "react";
import PropTypes from "prop-types";
import { Checkbox, Modal, Button } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { SortableContainer, SortableElement, arrayMove } from "react-sortable-hoc";

const ColumnItem = ({ selected, value, onSelected, columnKey }) => (
  // z-index was set to fix this: https://github.com/clauderic/react-sortable-hoc/issues/223
  <li style={{ zIndex: 1000000, listStyle: "none", padding: 8, border: "1px solid #e8e8e8", borderRadius: 2, cursor: "grab" }}>
    <Checkbox checked={selected} onChange={onSelected ? () => onSelected(!selected, columnKey) : undefined}>
      {value}
    </Checkbox>
  </li>
);
ColumnItem.propTypes = {
  selected: PropTypes.bool,
  value: PropTypes.string,
  onSelected: PropTypes.func,
  columnKey: PropTypes.string
};

const SortableItem = SortableElement(ColumnItem);

const ColumnList = ({ columns, columnKeysSelected, onItemSelected }) => (
  <ul style={{ height: 500, overflow: "auto", listStyle: "none", padding: 0 }}>
    {columns.map((o, index) => (
      <SortableItem
        key={o.key}
        index={index}
        value={o.title}
        columnKey={o.key}
        selected={columnKeysSelected.indexOf(o.key) < 0 ? false : true}
        onSelected={onItemSelected}
      />
    ))}
  </ul>
)
ColumnList.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  })),
  columnKeysSelected: PropTypes.arrayOf(PropTypes.string),
  onItemSelected: PropTypes.func
}

const SortableList = SortableContainer(ColumnList);

const TableColumnsSelector = ({
  columns: initialColumns,
  onChange,
  columnKeysSelected: initialColumnKeysSelected = []
}) => {
  const [columns, setColumns] = useState(initialColumns);
  const [columnKeysSelected, setColumnKeysSelected] = useState(initialColumnKeysSelected);
  const [visible, setVisible] = useState(false);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setColumns(arrayMove(columns, oldIndex, newIndex));
  };

  const updateSelection = (selected, columnKey) => {
    setColumnKeysSelected(selected
      ? [...columnKeysSelected, columnKey]
      : columnKeysSelected.filter(x => x !== columnKey)
    );
  };

  const confirmSelection = () => {
    const columnKeysSelectedSorted = columns.reduce((acc, o) => {
      if (columnKeysSelected.indexOf(o.key) >= 0) acc.push(o.key);
      return acc;
    }, []);
    setVisible(false);
    onChange(columnKeysSelectedSorted);
  };

  const title = "Select Table Columns";
  return (
    <>
      <Button icon={<MoreOutlined />} size="small" onClick={() => setVisible(true)}>
        {title}
      </Button>
      <Modal
        title={title}
        open={visible}
        onCancel={() => setVisible(false)}
        onOk={confirmSelection}
        footer={[
          <Button key="back" onClick={() => setVisible(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={confirmSelection}>
            Ok
          </Button>
        ]}
      >
        <SortableList
          columns={columns}
          columnKeysSelected={columnKeysSelected}
          onItemSelected={updateSelection}
          onSortEnd={onSortEnd}
          distance={5}
        />
      </Modal>
    </>
  );
}

TableColumnsSelector.propTypes = {
  columns: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  columnKeysSelected: PropTypes.arrayOf(PropTypes.string)
};

export default TableColumnsSelector;
